export default __webpack_public_path__ + "static/media/logo2.f8255226.png";